// @flow

import React, { Component } from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import { darken, transparentize } from 'polished';

import Icon from './Icon';

type FlashStyle = {|
  bg1: string,
  bg2: string,
  border: string,
  color: string
|}

function flashStyles(style: FlashStyle) {
  const amount = 0.025;
  return css`
    background-color: ${style.bg1};
    background-image: linear-gradient(to bottom, transparent, ${transparentize(0.85, style.bg2)});
    border-bottom: 1px solid ${style.border};
    color: ${style.color};
    &:hover {
      background-color: ${darken(amount, style.bg1)};
      border-bottom-color: ${darken(amount, style.border)};
    }
  `;
}

const FlashWrapper = styled.ul`
  font-size: 13px;
  line-height: 1.4;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FlashItem = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 1em 1.25em;
  padding-right: calc(1.25em + 10px);
  transition: 150ms linear all;

  @media (min-width: 375px) {
    padding: 1.5em;
  }

  p {
    margin: 0;
  }

  ${props => props.type && css`
    ${flashStyles(props.theme[props.type])}
  `}

  .ss-delete {
    position: absolute;
    right: 5px;
    top: 8px;
  }
`;

export type FlashTypes = 'error' | 'warning' | 'notice';

export type FlashType = {
  icon?: string,
  message: string,
  type?: FlashTypes
}

type FlashProps = {
  children: Node
}

const Flash = ({ children }: FlashProps) => (
  <FlashWrapper>
    {children}
  </FlashWrapper>
);

type FlashMessageProps = {
  children: Node,
  dismiss: (atIndex: number) => void,
  icon: string,
  index: number,
  type: FlashTypes
}

class FlashMessage extends Component<FlashMessageProps> {

  static defaultProps = {
    icon: 'alert',
    type: 'notice'
  }

  render() {
    const { children, index, dismiss, icon, type } = this.props;
    return (
      <FlashItem type={type} onClick={() => dismiss(index)}>
        <Icon type={icon} size={32} withMargin={true} />
        <p>
          {children}
        </p>
        <Icon type="delete" size={13} />
      </FlashItem>
    );
  }

}

export {
  Flash,
  FlashMessage
};

export default Flash;



// WEBPACK FOOTER //
// ./src/components/Flash.js